import * as actionTypes from '../actionTypes'
import ContactDomain from '../domains/ContactDomain'
import PoPreferenceDomain from '../domains/PoPreferenceDomain'
import AccountNumbersDomain from '../domains/AccountNumbersDomain'
import NotificationDomain from '../domains/NotificationDomain'
import TireDomain from '../domains/TireDomain'
import WheelDomain from '../domains/WheelDomain'
import { load as loadPref } from './util/loadPref'
import { load as loadLbbPref } from './util/loadLbbPref'

/*eslint radix: ["error", "as-needed"]*/

const homePage = (state = {
	isSaving: false,
	lbbFlag: false,
	saveSnack: false,
	errorSnack: false,
	accountTypeOptions: [],
	otherAccountTypes: [],
	countryTypeOptions: [],
	dealerNameOptions: [],
	dealerBtOptions: [],
	dealerStOptions: [],
	homeOfficeBtOptions: [],
	homeOfficeStOptions: [],
	contact: [],
	poPreference: new PoPreferenceDomain(),
	otherAccountNumbers: [],
	notifications: [],
	tires: [],
	wheels: [],
	diameterOptions: [],
	offsetOptions: [],
	materialTypeOptions: [],
	wheelTypeOptions: [],
	colorTypeOptions: [],
	driverAuthorizationTypeOptions: [],
	dispositionOfOffTireTypeOptions: [],
	beforeAndAfterOptions: [],
	axleTypeOptions: [],
	tireApplicationTypeOptions: [],
	requiredActivityTypeOptions: [],
	tireTypeOptions: [],
	tireBrandTypeOptions: [],
	tireSizeTypeOptions: [],
	tireTreadTypeOptions: [],
	loadRangeTypeOptions: [],
	wheelDiameterOptions: [],
	wheelOffsetOptions: [],
	wheelMaterialTypeOptions: [],
	homePageDomain: {},
	rerender: false,
	unsafeCancelOrSearch: false,
	disposition: '',
	isBillTo: false,
	isNAFA: false
}, action) => {
	switch (action.type) {
		case actionTypes.STARTING_SAVE:
			return {
				...state,
				isSaving: true,
				errorSnack: false
			}
		case actionTypes.SAVE_ERROR:
			return {
				...state,
				errorSnack: true,
				isSaving: false,
				errorMessage: action.message
			}
		case actionTypes.SNACK_CLOSE:
			return {
				...state,
				saveSnack: false
			}
		case actionTypes.HOMEPAGE_SAVE:
			return {
				unsafeCancelOrSearch: false,
				error: action.error,
				isSaving: false,
				saveSnack: true
			}
		case actionTypes.LOADED_INITIAL_DROPDOWN:
			return {
				...state,
				[action.field]: action.dropdown
			}
		case actionTypes.ACCOUNT_IDS:
			return {
				...state,
				lbbId: action.lbbId,
				nafaId: action.nafaId
			}
		case actionTypes.ACCOUNT_CHANGE_OLD: {
			let unsafeCancelOrSearch = state.unsafeCancelOrSearch
			if (!state.unsafeCancelOrSearch) {
				unsafeCancelOrSearch = true
			}
			let newHomePageDomain = state.homePageDomain
			newHomePageDomain.ersInstructions = action.value 

			return {
				...state,
				unsafeCancelOrSearch: unsafeCancelOrSearch,
				homePageDomain: newHomePageDomain
			}
		}
		case actionTypes.ACCOUNT_CHANGE: {
			let unsafeCancelOrSearch = state.unsafeCancelOrSearch
			if (!state.unsafeCancelOrSearch) {
				unsafeCancelOrSearch = true
			}
			return {
				...state,
				unsafeCancelOrSearch: unsafeCancelOrSearch,
				[action.field]: action.value
			}
		}
		case actionTypes.HOMEPAGE_CANCEL:
			return {
				...state,
				unsafeCancelOrSearch: false,
				rerender: !state.rerender,
				contact: [],
				poPreference: new PoPreferenceDomain(),
				otherAccountNumbers: [],
				notifications: [],
				tires: [],
				wheels: [],
				nafaData: [],
				homeOffice: '',
				subNafaOpen: false,
				subOpen: false,
				goBack: true,
				accountType: '',
				country: '',
				lbbAccountNumber: '',
				fleetName: '',
				fleetStreetAddress: '',
				fleetStreetAddressTwo: '',
				fleetCity: '',
				fleetStateProvince: '',
				fleetZipPostal: '',
				homePageDomain: {},
				dealerAddress: '',
				dealerCity: '',
				dealerState: '',
				dealerZip: '',
				ersInstructions: ''
			}
		case actionTypes.LBB_SEARCH:
			return {
				...state,
				dealerBtOptions: action.options
			}
		case actionTypes.DOMAIN_CHANGE: {
			let newHomePageDomain = state.homePageDomain
			newHomePageDomain[action.field] = action.value
			return {
				...state,
				homePageDomain: newHomePageDomain,
				rerender: !state.rerender,
				unsafeCancelOrSearch: true
			}
		}
		case actionTypes.ADDRESS_CHANGE: {
			return {
				...state,
				address: action.address
			}
		}
		case actionTypes.ACCOUNT_EDIT: {
			return {
				...state,
				storeAccountNumber: action.accountNumber,
				fleetName: action.accountName
			}
		}
		case actionTypes.PO_REQUIRED_CHANGE_ACTION: {
			let newPoPreference = state.poPreference 
			let val = action.value 
			newPoPreference[action.name] = val
			return {
				...state,
				poPreference: newPoPreference,
				rerender: !state.rerender,
				unsafeCancelOrSearch: true
			}
		}
		case actionTypes.CC_REQUIRED_CHANGE_ACTION: {
			let newPoPreference = state.poPreference

			newPoPreference[action.name] = action.value
			return {
				...state,
				poPreference: newPoPreference,
				rerender: !state.rerender,
				unsafeCancelOrSearch: true
			}
		}
		case actionTypes.CONTACT_CHANGE: {
			const nameArray = action.name.split('_')

			const index = parseInt(nameArray[0])
			const column = nameArray[1]

			const contact = state.contact[index]
			contact[column] = action.value

			if (!contact.isCreate) {
				contact.isUpdate = true
			}

			return {
				...state,
				contact: state.contact,
				unsafeCancelOrSearch: true
			}
		}
		case actionTypes.CONTACT_CHANGE_SELECT: {
			const nameArray = action.name.split('_')

			const index = parseInt(nameArray[0])
			const column = nameArray[1]

			const contact = state.contact[index]
			contact[column] = action.value

			if (!contact.isCreate) {
				contact.isUpdate = true
			}

			return {
				...state,
				contact: state.contact.slice(),
				unsafeCancelOrSearch: true
			}
		}
		case actionTypes.ADD_CONTACT: {
			const newContact = new ContactDomain()
			newContact.readOnly = false
			newContact.isCreate = true
			state.contact.push(newContact)
			let z = state.contact.slice()
			return {
				...state,
				contact: z,
				unsafeCancelOrSearch: true
			}
		}
		case actionTypes.REMOVE_CONTACT: {
			if (state.contact[action.index].isCreate) {
				state.contact.splice(action.index, 1)
			} else {
				state.contact[action.index].isDelete = true
				state.contact[action.index].isUpdate = false
			}
			return {
				...state,
				contact: state.contact.slice(),
				unsafeCancelOrSearch: true
			}
		}
		case actionTypes.PO_PREFERENCE_CHANGE: {
			const poName = action.name
			const poVarName = poName.substr(1)
			state.poPreference[poName.charAt(0)][poVarName] = action.value
			return {
				...state,
				poPreference: state.poPreference,
				unsafeCancelOrSearch: true
			}
		}
		case actionTypes.ADD_PO_PREFERENCE: {
			state.poPreference.push(new PoPreferenceDomain())
			let newPoPreference = state.poPreference.slice()
			return {
				...state,
				poPreference: newPoPreference,
				unsafeCancelOrSearch: true
			}
		}
		case actionTypes.REMOVE_PO_PREFERENCE:
			state.poPreference.splice(action.index, 1)
			return {
				...state,
				poPreference: state.poPreference.slice(),
				unsafeCancelOrSearch: true
			}

		case actionTypes.ACCOUNT_NUMBERS_CHANGE: {
			const nameArray = action.name.split('_')

			const index = parseInt(nameArray[0])
			const column = nameArray[1]

			const otherAccount = state.otherAccountNumbers[index]
			otherAccount[column] = action.value
			if (!otherAccount.isCreate) {
				otherAccount.isUpdate = true
			}

			return {
				...state,
				otherAccountNumbers: state.otherAccountNumbers,
				unsafeCancelOrSearch: true
			}
		}

		case actionTypes.ACCOUNT_NUMBERS_CHANGE_SELECT: {
			const nameArray = action.name.split('_')

			const index = parseInt(nameArray[0])
			const column = nameArray[1]

			const otherAccount = state.otherAccountNumbers[index]
			otherAccount[column] = action.value
			if (!otherAccount.isCreate) {
				otherAccount.isUpdate = true
			}

			return {
				...state,
				otherAccountNumbers: state.otherAccountNumbers.slice(),
				unsafeCancelOrSearch: true
			}
		}

		case actionTypes.ADD_ACCOUNT_NUMBERS: {
			const newOtherAccount = new AccountNumbersDomain()
			newOtherAccount.isCreate = true
			state.otherAccountNumbers.push(newOtherAccount)
			return {
				...state,
				otherAccountNumbers: state.otherAccountNumbers.slice(),
				unsafeCancelOrSearch: true
			}
		}
		case actionTypes.REMOVE_ACCOUNT_NUMBERS:
			if (state.otherAccountNumbers[action.index].isCreate) {
				state.otherAccountNumbers.splice(action.index, 1)
			} else {
				state.otherAccountNumbers[action.index].isDelete = true
				state.otherAccountNumbers[action.index].isUpdate = false
			}
			return {
				...state,
				otherAccountNumbers: state.otherAccountNumbers.slice(),
				unsafeCancelOrSearch: true
			}
		case actionTypes.NOTIFICATION_CHANGE: {
			const notificationsName = action.name
			const notificationsVarName = notificationsName.substr(1)
			const notif = state.notifications[notificationsName.charAt(0)]
			notif[notificationsVarName] = action.value
			if (!notif.isCreate) {
				state.notifications[notificationsName.charAt(0)].isUpdate = true
			}
			return {
				...state,
				notifications: state.notifications.slice(),
				unsafeCancelOrSearch: true
			}
		}
		case actionTypes.ADD_NOTIFICATION: {
			const newNotification = new NotificationDomain()
			newNotification.isCreate = true
			state.notifications.push(newNotification)
			return {
				...state,
				notifications: state.notifications.slice(),
				unsafeCancelOrSearch: true
			}
		}
		case actionTypes.REMOVE_NOTIFICATION: {
			if (state.notifications[action.index].isCreate) {
				state.notifications.splice(action.index, 1)
			} else {
				state.notifications[action.index].isDelete = true
				state.notifications[action.index].isUpdate = false
			}

			return {
				...state,
				notifications: state.notifications.slice(),
				unsafeCancelOrSearch: true
			}
		}

		case actionTypes.WHEEL_CHANGE_SELECT: {
			const nameArray = action.name.split('_')

			const index = parseInt(nameArray[0])
			const column = nameArray[1]

			const wheel = state.wheels[index]
			wheel[column] = action.value

			if (!wheel.isCreate) {
				wheel.isUpdate = true
			}

			return {
				...state,
				wheels: state.wheels.slice(),
				unsafeCancelOrSearch: true
			}
		}

		case actionTypes.WHEEL_CHANGE: {
			const nameArray = action.name.split('_')

			const index = parseInt(nameArray[0])
			const column = nameArray[1]

			const wheel = state.wheels[index]
			wheel[column] = action.value

			if (!wheel.isCreate) {
				wheel.isUpdate = true
			}
			
			return {
				...state,
				wheels: state.wheels,
				unsafeCancelOrSearch: true
			}
		}
		case actionTypes.ADD_WHEEL: {
			const newWheel = new WheelDomain()
			newWheel.isCreate = true
			state.wheels.push(newWheel)
			return {
				...state,
				wheels: state.wheels.slice(),
				unsafeCancelOrSearch: true
			}
		}
		case actionTypes.REMOVE_WHEEL: {
			if (state.wheels[action.index].isCreate) {
				state.wheels.splice(action.index, 1)
			} else {
				state.wheels[action.index].isDelete = true
				state.wheels[action.index].isUpdate = false
			}

			return {
				...state,
				wheels: state.wheels.slice(),
				unsafeCancelOrSearch: true
			}
		}

		case actionTypes.TIRE_CHANGE: {
			const nameArray = action.name.split('_')

			const index = parseInt(nameArray[0])
			const column = nameArray[1]

			const tire = state.tires[index]
			tire[column] = action.value

			if (!tire.isCreate) {
				tire.isUpdate = true
			}
			return {
				...state,
				tires: state.tires,
				unsafeCancelOrSearch: true,
			}
		}

		case actionTypes.TIRE_CHANGE_SELECT: {
			const nameArray = action.name.split('_')

			const index = parseInt(nameArray[0])
			const column = nameArray[1]

			const tire = state.tires[index]
			tire[column] = action.value

			if (!tire.isCreate) {
				tire.isUpdate = true
			}

			return {
				...state,
				tires: state.tires.slice(),
				unsafeCancelOrSearch: true,
			}
		}
		case actionTypes.ADD_TIRE: {
			let newTire = new TireDomain()

			if (action) {
				newTire.requiredActivity = action.requiredActivity
				newTire.axleType = action.axleType
				newTire.application = action.tireApplicationId
				newTire.tireType = action.tireType
				newTire.tireBrand = action.tireBrand
				newTire.tireSize = action.tireSize
				newTire.tread = action.tread
				newTire.loadRange = action.loadRange
				newTire.fleetLocationId = action.fleetLocationId
			}

			newTire.isCreate = true
			state.tires.push(newTire)
			return {
				...state,
				tires: state.tires.slice(),
				unsafeCancelOrSearch: true
			}
		}
		case actionTypes.REMOVE_TIRE:

			if (state.tires[action.index].isCreate) {
				state.tires.splice(action.index, 1)
			} else {
				state.tires[action.index].isDelete = true
				state.tires[action.index].isUpdate = false
			}
			return {
				...state,
				tires: state.tires.slice(),
				unsafeCancelOrSearch: true
			}
		case actionTypes.LOAD_PREF: {
			let ret = {}
			
			if (action.lbb) {
				ret = loadLbbPref(action.pref, state)
			} else {
				ret = loadPref(action.pref, state, action.billToContacts, action.billToInfo)
			}

			return {
				...state,
				unsafeCancelOrSearch: false,
				errorSnack: false,
				nafaData: [],
				subNafaOpen: false,
				subOpen: false,
				goBack: true,
				accountType: ret.accountType,
				country: action.pref.address.countryId,
				dealerBt: ret.billTo,
				dealerId: ret.dealerId,
				dealerLocationId: ret.dealerLocationId,
				dealerName: ret.dealerName,
				storeAccountNumber: ret.storeAccountNumber,
				contact: ret.contacts,
				poPreference: ret.poPreference,
				otherAccountNumbers: ret.newOtherAccounts,
				fleetName: action.pref.name,
				homePageDomain: ret.newHomePage,
				ersInstructions: ret.ersInstructions,
				address: ret.address,
				fleetLocationIdentifier: ret.fleetLocationIdentifier,
				billTo: ret.billTo,
				shipTo: ret.shipTo,
				isBillTo: ret.isBillTo,
				isShipTo: ret.isShipTo,
				tires: ret.newTires,
				wheels: ret.newWheels,
				isSaving: false, 
				driverAuthorization: ret.authorizationPreference,
				disposition: ret.disposition
			}
		}
		case actionTypes.DIALOG_SEARCH:
			return {
				...state,
				nafaData: action.data,
				subNafaOpen: !action.isLbb,
				subOpen: action.isLbb,
				isLbb: action.isLbb,
				lbbFlag: action.isLbb,
				moreResults: action.moreResults,
			}
		case actionTypes.LOAD_SHIP_TOS:
			return {
				...state,
				homeOfficeStOptions: action.data
			}
		case actionTypes.LOAD_BILL_TOS:
			return {
				...state,
				homeOfficeBtOptions: action.data
			}
		default:
			return {
				...state,
				goBack: false,
				subNafaOpen: false,
				subOpen: false,
			}
	}
}

export default homePage


// WEBPACK FOOTER //
// ./src/reducers/homePage.js